<template>
    <div>
        <div class="d-flex flex-column flex-md-row gap mb-2">
            <button
                @click="changeView(0)"
                type="button"
                class="btn btn-outline-primary"
            >
                Resumen
            </button>
            <button
                @click="changeView(1)"
                type="button"
                class="btn btn-outline-primary"
            >
                Listar Jurados
            </button>
            <button
                @click="changeView(4)"
                type="button"
                class="btn btn-outline-primary"
            >
                Inscribir Jurado
            </button>
        </div>

        <contest-sworn-resume-component
            v-if="page == 0"
            @change="changeView"
            v-bind:contestId="model_id"
        ></contest-sworn-resume-component>
        <contest-sworn-list-component
            v-if="page == 1"
            @change="changeViewWithParams"
            v-bind:contestId="model_id"
        ></contest-sworn-list-component>
        <contest-sworn-show-component
            v-if="page == 2"
            @change="changeView"
            v-bind:contestId="model_id"
        ></contest-sworn-show-component>
        <contest-sworn-edit-component
            v-if="page == 3"
            @change="changeView"
            v-bind:contestId="model_id"
            v-bind:params="params"
        ></contest-sworn-edit-component>
        <contest-sworn-create-component
            v-if="page == 4"
            @change="changeView"
            v-bind:contestId="model_id"
        ></contest-sworn-create-component>
    </div>
</template>
<script>
export default {
    props: {
        model_id: Number,
    },
    data() {
        return {
            page: 0,
            params: {},
        };
    },
    methods: {
        changeView(page) {
            this.page = page;
        },

        changeViewWithParams(params) {
            this.params = params;
            this.page = params.page;
        },
    },
};
</script>
<style scoped>
.gap {
    gap: 0.5em;
}

.btn {
    border-radius: 0.2rem;
}
</style>
